<template>
  <b-modal
    size="xl"
    centered
    :visible="visible"
    hide-footer
    hide-header-close
    no-close-on-esc
    no-close-on-backdrop
    title-tag="h2"
  >
    <half-circle-spinner v-if="isLoading" />
    <template v-else>
      <div slot="modal-title" class="v2_info-popup__title">
        <slot name="title">
          <div v-if="content && content.heading" class="v2_info-popup__title">
            {{ content.heading }}
          </div>
        </slot>
      </div>

      <slot :content="content" />
      <div class="mt-5">
        <p class="d-flex justify-content-center">
          <b-button variant="v3_teal_outline" @click="onClose">Close</b-button>
        </p>
      </div>
      <slot name="footer">
        <div
          v-if="withCancelPossibility"
          class="v2_info-popup__footer d-flex align-items-center justify-content-center"
        >
          You can view this at any time by clicking the
          <i class="mdi mdi-information-outline pl-1" />
        </div>
      </slot>
    </template>
  </b-modal>
</template>

<script>
import {
  SET_POPUP_VISIBILITY_MUTATION,
} from '@/store';
import Api from '@/providers/Api';
import { HalfCircleSpinner } from 'epic-spinners';

export default {
  name: 'InfoPopup',
  model: {
    prop: 'visible',
    event: 'close',
  },
  components: {
    HalfCircleSpinner,
  },
  props: {
    settingKey: {
      type: String,
      required: true,
    },
    userSettingsKey: {
      validator: (prop) => typeof prop === 'string' || prop === null,
      default: null,
    },
    visible: {
      type: Boolean,
      required: false,
    },
    withCancelPossibility: {
      type: Boolean,
      default: false,
    },
    autoShowOnlyOnce: {
      type: Boolean,
      default: false,
    },
    contentRoute: {
      validator: (prop) => typeof prop === 'string' || prop === null,
      default: null,
    },
  },
  data: function () {
    return {
      doNotShowAgain: false,
      content: null,
      isLoading: false,
    };
  },
  created: function () {
    this.getContent();
  },
  methods: {
    onClose: function () {
      this.$emit('close', false);
    },
    getContent: async function () {
      if (!this.contentRoute) return;
      this.isLoading = true;
      try {
        this.content = await Api.getDynamicContentByRoute(this.contentRoute);
      } catch {
        this.$toasted.error(
          'Unable to upload page content. Please try again later',
          { duration: 3000 }
        );
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.$store.commit(SET_POPUP_VISIBILITY_MUTATION, {
      key: this.settingKey,
      value: false,
    });
  },
};
</script>

<style lang="scss"></style>
